// extracted by mini-css-extract-plugin
module.exports = {"header-icon":"header-icon__xl90P","svg":"svg__258kQ","item":"item__3IXXF","href":"href__R3Ubp","contact-header":"contact-header__33uhv","contact-label":"contact-label__2UoNn"};